document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.mobile-menu-button');
  const nav = document.querySelector('.primary-nav');

  if (button && nav) {
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open');
      document.body.classList.toggle('menu-open', !open);
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.velocity-gallery__main-image');
    const stage = gallery.querySelector('[data-product-gallery-stage]');
    const thumbnails = gallery.querySelectorAll('[data-product-gallery-thumbnail]');

    if (!mainImage || !thumbnails.length) return;

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const nextSrc = thumbnail.dataset.imageSrc;
        const nextAlt = thumbnail.dataset.imageAlt || '';
        const nextWidth = Number(thumbnail.dataset.imageWidth);
        const nextHeight = Number(thumbnail.dataset.imageHeight);

        if (!nextSrc || mainImage.src === nextSrc) return;

        mainImage.classList.add('is-changing');
        const preload = new Image();
        preload.src = nextSrc;
        preload.onload = () => {
          mainImage.src = nextSrc;
          mainImage.alt = nextAlt;
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');

          if (stage) {
            const width = nextWidth || preload.naturalWidth;
            const height = nextHeight || preload.naturalHeight;
            if (width > 0 && height > 0) {
              stage.style.aspectRatio = `${width} / ${height}`;
            }
          }

          mainImage.classList.remove('is-changing');
        };

        thumbnails.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');
      });
    });
  });
});


// Update cart quantities without leaving the current theme preview.
document.addEventListener('DOMContentLoaded', () => {
  const cartForm = document.querySelector('[data-cart-form]');
  if (!cartForm) return;

  const updateButton = cartForm.querySelector('[data-cart-update]');
  const cartRoot = window.Shopify?.routes?.root || '/';
  const updateUrl = `${cartRoot}cart/update.js`;

  cartForm.addEventListener('submit', async (event) => {
    const submitter = event.submitter;

    // Let Shopify handle checkout normally.
    if (submitter && submitter.name === 'checkout') return;

    event.preventDefault();

    const updates = {};
    cartForm.querySelectorAll('[data-cart-quantity]').forEach((input) => {
      const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
      updates[input.dataset.lineKey] = quantity;
    });

    if (updateButton) {
      updateButton.disabled = true;
      updateButton.setAttribute('aria-busy', 'true');
      updateButton.dataset.originalText = updateButton.textContent;
      updateButton.textContent = 'Updating…';
    }

    try {
      const response = await fetch(updateUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error(`Cart update failed with status ${response.status}`);
      }

      // Reload the exact same URL so preview_theme_id and other preview
      // parameters remain attached instead of returning to the live theme.
      window.location.reload();
    } catch (error) {
      console.error(error);
      alert('The cart could not be updated. Please try again.');

      if (updateButton) {
        updateButton.disabled = false;
        updateButton.removeAttribute('aria-busy');
        updateButton.textContent = updateButton.dataset.originalText || 'Update cart';
      }
    }
  });
});


// Build a seamless available-PC loop and start it only when it enters view.
(() => {
  const initialized = new WeakSet();

  const initAvailablePcMarquees = (root = document) => {
    root.querySelectorAll('[data-pc-marquee]').forEach((viewport) => {
      if (window.matchMedia('(max-width: 620px)').matches) return;
      if (initialized.has(viewport)) return;

      const track = viewport.querySelector('[data-pc-marquee-track]');
      const firstGroup = track?.querySelector('.velocity-pc-marquee__group');
      const firstCard = firstGroup?.querySelector('.velocity-pc-marquee__card');
      if (!track || !firstGroup || !firstCard) return;

      initialized.add(viewport);

      const cloneGroup = () => {
        const clone = firstGroup.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      };


      const rebuildLoop = () => {
        const shouldResume = viewport.classList.contains('is-running');

        viewport.classList.remove('is-running');
        track.style.animation = 'none';
        track.querySelectorAll('.velocity-pc-marquee__group:not(:first-child)').forEach((group) => group.remove());

        const groupWidth = firstGroup.getBoundingClientRect().width;
        const cardWidth = firstCard.getBoundingClientRect().width;
        const viewportWidth = viewport.clientWidth;
        if (!groupWidth || !cardWidth || !viewportWidth) return;

        // Put the original sequence in the middle of matching copies. This lets
        // the first card start centered while previous copies fill the left side,
        // so the animation never exposes a blank area when it loops.
        const groupsPerSide = Math.max(3, Math.ceil(viewportWidth / groupWidth) + 2);
        const totalGroups = groupsPerSide * 2 + 1;

        for (let index = 1; index < totalGroups; index += 1) {
          track.appendChild(cloneGroup());
        }

        const centerOffset = (viewportWidth - cardWidth) / 2;
        const startOffset = centerOffset - (groupsPerSide * groupWidth);
        const endOffset = startOffset - groupWidth;

        track.style.setProperty('--marquee-start', `${startOffset}px`);
        track.style.setProperty('--marquee-end', `${endOffset}px`);
        track.style.setProperty('--marquee-distance', `${groupWidth}px`);

        track.getBoundingClientRect();
        track.style.animation = '';

        if (shouldResume) {
          requestAnimationFrame(() => viewport.classList.add('is-running'));
        }
      };

      const resetAndRun = () => {
        viewport.classList.remove('is-running');

        track.style.animation = 'none';
        track.getBoundingClientRect();
        track.style.animation = '';
        requestAnimationFrame(() => viewport.classList.add('is-running'));
      };

      rebuildLoop();

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          const wasRunning = viewport.classList.contains('is-running');
          rebuildLoop();
          if (wasRunning) resetAndRun();
        }, 180);
      });

      const isMobileMarquee = window.matchMedia('(max-width: 620px)').matches;

      // On phones, start immediately and keep running. Mobile browsers and
      // Shopify's preview iframe can report inconsistent intersection/focus
      // states, which was causing the row to remain paused.
      if (isMobileMarquee) {
        resetAndRun();
      } else if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              resetAndRun();
            } else {
              viewport.classList.remove('is-running');
            }
          });
        }, { threshold: 0.35 });

        observer.observe(viewport);
      } else {
        resetAndRun();
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initAvailablePcMarquees());
  document.addEventListener('shopify:section:load', (event) => initAvailablePcMarquees(event.target));
})();

// Keep the PC-drop form inside the hero on desktop, but place it after the
// available-PC carousel on phones so shoppers see current inventory first.
(() => {
  const MOBILE_QUERY = '(max-width: 620px)';

  const positionPcDropForm = () => {
    const form = document.querySelector('.velocity-hero__drop-form');
    const anchor = document.querySelector('.velocity-hero__drop-form-anchor');
    const inventory = document.querySelector('.velocity-pc-marquee');
    if (!form || !anchor || !inventory) return;

    if (window.matchMedia(MOBILE_QUERY).matches) {
      if (inventory.nextElementSibling !== form) {
        inventory.insertAdjacentElement('afterend', form);
      }
      form.classList.add('is-mobile-relocated');
    } else {
      if (anchor.nextElementSibling !== form) {
        anchor.insertAdjacentElement('afterend', form);
      }
      form.classList.remove('is-mobile-relocated');
    }
  };

  let resizeTimer;
  const queuePosition = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(positionPcDropForm, 80);
  };

  document.addEventListener('DOMContentLoaded', positionPcDropForm);
  document.addEventListener('shopify:section:load', () => window.setTimeout(positionPcDropForm, 0));
  document.addEventListener('shopify:section:reorder', () => window.setTimeout(positionPcDropForm, 0));
  window.addEventListener('resize', queuePosition);
})();
